export type FormKind = "create" | "evaluate" | "complete" | "verify" | null;

export type FormErrors = Record<string, string>;

export function validateForm(
  kind: Exclude<FormKind, null>,
  form: Record<string, string>,
): FormErrors {
  const errors: FormErrors = {};
  const requireLength = (name: string, minimum: number, message: string) => {
    if ((form[name] ?? "").trim().length < minimum) errors[name] = message;
  };

  if (kind === "create") {
    requireLength("title", 5, "Başlık en az 5 karakter olmalıdır.");
    requireLength(
      "description",
      10,
      "Uygunsuzluğu en az 10 karakterle açıklayın.",
    );
    if (!form.sourceType) errors.sourceType = "Uygunsuzluk kaynağını seçin.";
    if (!form.severity) errors.severity = "Önem derecesini seçin.";
  }
  if (kind === "evaluate") {
    requireLength(
      "containmentAction",
      10,
      "Geçici önlemi en az 10 karakterle açıklayın.",
    );
    requireLength("rootCause", 10, "Kök nedeni en az 10 karakterle açıklayın.");
    requireLength(
      "actionPlan",
      10,
      "Faaliyet planını en az 10 karakterle açıklayın.",
    );
    requireLength("actionOwnerName", 2, "Faaliyet sorumlusunu yazın.");
    if (!form.dueAt) errors.dueAt = "Termin tarihini seçin.";
  }
  if (kind === "complete") {
    requireLength(
      "completionNote",
      10,
      "Tamamlama açıklaması en az 10 karakter olmalıdır.",
    );
    requireLength("evidenceReference", 3, "Geçerli bir kanıt referansı yazın.");
  }
  if (kind === "verify") {
    if (!["true", "false"].includes(form.effective ?? "")) errors.effective = "Etkinlik sonucunu seçin.";
    requireLength(
      "effectivenessNote",
      10,
      "Değerlendirmeyi en az 10 karakterle açıklayın.",
    );
  }
  return errors;
}
